export default "__VITE_ASSET__0ErG1czH__"